import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "w-full flex justify-start" }
const _hoisted_2 = { class: "w-full text-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FormMeeting = _resolveComponent("FormMeeting")!
  const _component_Dialog = _resolveComponent("Dialog")!
  const _component_TableAgenda = _resolveComponent("TableAgenda")!

  return (_openBlock(), _createElementBlock("section", null, [
    _createElementVNode("div", _hoisted_1, [
      _renderSlot(_ctx.$slots, "header")
    ]),
    _createVNode(_component_Dialog, {
      visible: _ctx.formVisibility,
      "onUpdate:visible": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.formVisibility) = $event)),
      draggable: false,
      modal: true,
      breakpoints: { '960px': '75vw', '640px': '90vw' },
      style: { width: '50vw' }
    }, {
      header: _withCtx(() => [
        _createElementVNode("h5", _hoisted_2, _toDisplayString(_ctx.$t("classes.event.add")), 1)
      ]),
      default: _withCtx(() => [
        _createVNode(_component_FormMeeting, {
          eventForm: _ctx.eventForm,
          "onUpdate:eventForm": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.eventForm) = $event)),
          isExternal: _ctx.isExternal,
          "onUpdate:isExternal": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.isExternal) = $event)),
          vuelidate$: _ctx.v$,
          onOnClose: _cache[2] || (_cache[2] = ($event: any) => (_ctx.closeForm())),
          onOnSubmit: _cache[3] || (_cache[3] = ($event: any) => (_ctx.submitForm())),
          loading: _ctx.loading
        }, null, 8, ["eventForm", "isExternal", "vuelidate$", "loading"])
      ]),
      _: 1
    }, 8, ["visible"]),
    _createVNode(_component_TableAgenda, { eventCreated: _ctx.eventCreated }, null, 8, ["eventCreated"])
  ]))
}